module.exports = __webpack_public_path__ + "img/Graph-3.839e905e.svg";